import './NavItem.scss';
import { useRef } from 'react';

export default function NavItem(props: {title: string, highlightedTitle: string}) {
    
    let ref = useRef<HTMLAnchorElement>(null);
    let navCode: string = props.title.toLowerCase(); 
    let className = `nav-item ${props.highlightedTitle === props.title.toLowerCase() ? '-selected' : ''}`;
    
    let navItem: JSX.Element = <a tab-index="0" className={className} ref={ref} href={`#${navCode}`} onClick={e => handleClick(e)}>
        <span className='text'>{props.title}</span>
        <div className='hover-border'/>
    </a>;

    let handleClick = (e: React.MouseEvent) => {
        ref.current?.closest('.navbar')?.querySelectorAll('.nav-item')
            .forEach((element: Element) => {
                element.classList.remove('-selected');
            });
    };


    return navItem;
};